// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminTitle_wrapper__eCyxA","block":"AdminTitle_block__g82Gj","title":"AdminTitle_title__AYyE9"};